module.exports = "mutation ($id: ID!, $data: FormInput!) {\n  FormUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"